import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ProfilePicture from "../../components/profielPicture";
import ProfileImage from "../../components/ProfileImage";
import Friendship from "./Friendship";
import UpdateProfilePicture from "../../components/profielPicture/UpdateProfilePicture";
import { getProfileImageUrl } from "../../helpers/getGravatarUrl";

//export const profilePicture = "https://example.com/path-to-profile-image.jpg";

export default function ProfielPictureInfos({
  profile,
  updateProfilePicture,
  visitor,
  photos,
  othername,
  onUpdateProfilePictureOpen,
}) {
  const [show, setShow] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const [editorImage, setEditorImage] = useState("");
  const fileInputRef = useRef(null);
  const [profileImageError, setProfileImageError] = useState(false);
  const pRef = useRef(null);

  // Reset image error when profile changes
  useEffect(() => {
    setProfileImageError(false);
  }, [profile.picture]);

  // Notify parent component when modal state changes
  useEffect(() => {
    if (onUpdateProfilePictureOpen) {
      onUpdateProfilePictureOpen(showEditor);
    }
  }, [showEditor, onUpdateProfilePictureOpen]);

  const handleProfilePictureUpdate = (newPicture) => {
    updateProfilePicture(newPicture);
    setShow(false);
  };


  // Close editor if image cleared from inside editor
  const handleSetEditorImage = (img) => {
    if (!img) setShowEditor(false);
    setEditorImage(img);
  };

  return (
    <div className="profile_img_wrap">
      {show && (
        <ProfilePicture
          setShow={setShow}
          pRef={pRef}
          photos={photos}
          onProfilePictureUpdate={handleProfilePictureUpdate}
        />
      )}
      {/* New: direct editor overlay for existing profile picture */}
      {showEditor && (
        <div className="blur">
          <UpdateProfilePicture
            setImage={handleSetEditorImage}
            image={editorImage}
            setShow={setShowEditor}
            setError={() => {}}
            pRef={pRef}
          />
        </div>
      )}
      <div className="profile_w_left">
        <div className="profile_w_img">
          <div className="profile_w_bg" ref={pRef}>
            <img
              src={
                profileImageError
                  ? "/images/default_pic.png"
                  : getProfileImageUrl(profile.picture, profile.email, 200)
              }
              alt={profile.name || "Profile"}
              className="profile_w_img_tag"
              onError={() => setProfileImageError(true)}
              onLoad={() => setProfileImageError(false)}
            />
          </div>
          {!visitor && (
            <div className="profile_circle_wrap">
              <div
                className="profile_circle hover1"
                onClick={() => fileInputRef.current.click()}
              >
                <i className="camera_filled_icon"></i>
              </div>
              <input
                type="file"
                ref={fileInputRef}
                hidden
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      setEditorImage(event.target.result);
                      setShowEditor(true);
                    };
                    reader.readAsDataURL(file);
                  }
                }}
              />
            </div>
          )}
        </div>
        <div className="profile_w_col">
          <div className="profile_identity">
            <div className="profile_name">
              {profile.name ||
                `${profile.first_name || ""} ${profile.last_name || ""}`.trim() ||
                "Unknown User"}
              <div className="othername">{othername && `(${othername})`}</div>
            </div>
            <div className="profile_friend_count">
              {profile?.friends && (
                <div className="profile_card_count friends_count">
                  {profile?.friends.length === 0
                    ? ""
                    : profile?.friends.length === 1
                    ? "1 Friend"
                    : `${profile?.friends.length} Friends`}
                </div>
              )}
            </div>
          </div>
          <div className="profile_friend_imgs">
            {profile?.friends &&
              profile.friends.slice(0, 6).map((friend, i) => (
                <Link
                  to={`/profile/${friend.username || friend._id}`}
                  key={friend._id || i}
                >
                  <ProfileImage
                    src={friend.picture}
                    email={friend.email}
                    alt={friend.name || `${friend.first_name || ""} ${friend.last_name || ""}`.trim() || "Friend"}
                    style={{
                      transform: `translateX(${-i * 7}px)`,
                      zIndex: `${i}`,
                      width: '42px',
                      height: '42px',
                      objectFit: 'cover',
                      borderRadius: '50%'
                    }}
                    placeholderText=""
                  />
                </Link>
              ))}
          </div>
        </div>
      </div>
      {visitor ? (
        <Friendship friendshipp={profile?.friendship} profileid={profile._id} />
      ) : (
        <div className="profile_w_right">
<div
            className="gray_btn"
            onClick={() => {
              setEditorImage(profile.picture || "/images/default_pic.png");
              setShowEditor(true);
            }}
          >
            <i className="edit_icon"></i>
            <span>Edit profile</span>
          </div>
        </div>
      )}
    

    </div>
  );
}
